import React from "react";
import DateHelpers from '../Helper/DateHelpers.js';
import { useState, useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import CurrencyInput from 'react-currency-input-field';
import { SafeAreaView, StyleSheet, TextInput } from 'react-native';
import '../Styles/AddTransaction.scss';


function AddTransaction({amount_due, regist_id, currentAmountDue, setCurrentAmountDue, setAddPaymentVisibility}) {

   const [checkNumber, setCheckNumber] = useState('')
   const [creditCardNumber, setCreditCardNumber]= useState('')
   const [invalidOptionsError, setInvalidOptionsError] = useState(false)
   const [invalidTransactionValue, setInvalidTransactionValue] = useState(false)
   const navigate = useNavigate()
   const params = useParams()
   const [paymentType, setPaymentType] = useState('')
   const [successfulPaymentMessage, setSuccessfulPaymentMessage] = useState(false)
   const [transactionValue, setTransactionValue] = useState()

   // Call this on page load and after updating amount due
   async function GetCurrentAmountDue() {
      const registId = regist_id
      const amountDueRequest = await fetch('/getcurrentamountdue', {
         method: 'POST',
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
            registId
         })
      })
      var amountDueResponse = await amountDueRequest.json()
      console.log("amount due response", amountDueResponse.data.amountDue[0].amount_due)
      var amountDue = amountDueResponse.data.amountDue[0].amount_due;
      setCurrentAmountDue(amountDue)
   }

   async function UpdateAmountDue() {

      try {
         if ((paymentType == 'check' && transactionValue != null && checkNumber != '') || (paymentType == 'cash' && transactionValue != null) || (paymentType === 'credit' && transactionValue != null)) {
            if (Math.fround(transactionValue) <= Math.fround(currentAmountDue)) {
               const registId = regist_id
               console.log("registration id", registId)
               const UpdateAmountDueRequest = await fetch('/updateamountduemanual', {
                  method: 'POST',
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                     transactionValue,
                     registId,
                     checkNumber,
                     creditCardNumber,
                     paymentType
                  })
               })
               setSuccessfulPaymentMessage(true)
               GetCurrentAmountDue()
            }
            else {
               console.log("Not Less or Equal")
               setInvalidTransactionValue(true)
            }
         }
         else {
            setInvalidOptionsError(true)
         }
      } catch (error) {
         console.log(error)
      }

   }

   // Set payment type based on ratio button
   function handleTransactionType(value) {

      // Clear error messages
      setInvalidOptionsError(false)
      setInvalidTransactionValue(false)
      setSuccessfulPaymentMessage(false)

      // Set selected payment type
      setPaymentType(value)
   }

   const handleTransactionValue = (text) => {
      try {

         // Clear error messages
         setInvalidOptionsError(false)
         setInvalidTransactionValue(false)
         setSuccessfulPaymentMessage(false)

         // Set transaction value
         setTransactionValue(text)
      } catch (error) {
         console.log(error)
      }
   }

   // Validate check number entry as only integer values
   const handleCheckNumber = (text) => {
      try {

         // Clear error messages
         setInvalidOptionsError(false)
         setInvalidTransactionValue(false)
         setSuccessfulPaymentMessage(false)

         const cleanedValue = text.replace(/[^0-9]/g, '')
         const parsedValue = parseInt(cleanedValue, 10)

         if (!isNaN(parsedValue)) {
            setCheckNumber(parsedValue.toString())
         }
         else {
            setCheckNumber('')
         }
      } catch (error) {
         console.log(error)
      }
   }

      // Validate check number entry as only integer values
      const handleCreditNumber = (text) => {
         try {
   
            // Clear error messages
            setInvalidOptionsError(false)
            setInvalidTransactionValue(false)
            setSuccessfulPaymentMessage(false)
   
            const cleanedValue = text.replace(/[^0-9]/g, '')
            const parsedValue = parseInt(cleanedValue, 10)
   
            if (!isNaN(parsedValue)) {
               setCreditCardNumber(parsedValue.toString())
            }
            else {
               setCreditCardNumber('')
            }
         } catch (error) {
            console.log(error)
         }
      }
   

   useEffect(() => {
      GetCurrentAmountDue()
   }, []);

   return (
         <div className="AddTransactionContainer">
            <div className="AddTransactionContent">
               <div className="AddTransactionHeading">
                  <div className="AddTransactionHeadingText">
                     Add Payments
                  </div>
               </div>
               <div className="AddTransactionPaymentEntry">
                  <div className="AddTransactionPaymentEntryCurrentAmountDueHeading">
                     Current Amount Due
                  </div>
                  <div className="AddTransactionPaymentEntryCurrentAmountDue">
                     ${currentAmountDue}
                  </div>
                  <div className="AddTransactionPaymentEntryPaymentTypeRatioButtons">
                     <div className="TransactionCashSelection"
                        onChange={(event) => handleTransactionType(event.target.value)}>
                        Cash {" "}

                        <input label='Cash' id="TransactionCashSelection" type="radio" value="cash" name="TransactionSelection" />
                     </div>
                     <div className="TransactionCheckSelection"
                        onChange={(event) => handleTransactionType(event.target.value)}>
                        Check<input label='Cash' id="TransactionCashSelection" type="radio" value="check" name="TransactionSelection" />
                     </div>
                     <div className="TransactionCreditSelection"
                     onChange={(event) => handleTransactionType(event.target.value)}>
                        Credit<input label='Cash' id="TransactionCashSelection" type="radio" value="credit" name="TransactionSelection" />
                     </div>
                  </div>

                  <div className="AddTransactionPaymentEntryPaymentEntry">
                     <CurrencyInput
                        id="input-example"
                        name="input-name"
                        placeholder="Payment amount"
                        decimalsLimit={2}
                        value={transactionValue}
                        prefix={'$'}
                        onValueChange={(value, name, values) => handleTransactionValue(value)}
                     />
                  </div>

                  {paymentType == 'check' &&
                     <div className="AddTransactionPaymentEntryCheckEntry">
                        <input
                           type='numeric'
                           value={checkNumber}
                           maxLength={4}
                           onChange={(event) => handleCheckNumber(event.target.value)}
                           placeholder="4-digit check number"
                        />
                  </div>
               }
               {paymentType == 'credit' &&
                  <div className="AddTransactionPaymentEntryCreditEntry">
                     <input
                        type='numeric'
                        value={creditCardNumber}
                        maxLength={4}
                        onChange={(event) => handleCreditNumber(event.target.value)}
                        placeholder="last 4 credit card digits"
                     />
                  </div>
               }
               <div className="AddTransactionSubmit">
                  <div className="AddTransactionSubmitInvisibleDiv">
                     </div>
                     <div className="AddTransactionSubmitButton">
                        <button onClick={() => UpdateAmountDue()} disabled={currentAmountDue == 0.00}>
                           Submit
                        </button>
                     </div>
                     <div className="AddTransactionSubmitBackButton">
                        <button onClick={() => setAddPaymentVisibility(false)}>
                           Close
                        </button>
                     </div>
                  </div>
                  {invalidTransactionValue == true &&
                     <div className="InvalidTransactionValueError">
                        Entered payment cannot be greater than the amount due.
                     </div>
                  }
                  {invalidOptionsError === true &&
                     <div className="InvalidFieldsError">
                        All fields must be filled out.
                     </div>
                  }
                  {successfulPaymentMessage === true &&
                     <div className="SuccessfulPaymentMessage">
                        Payment submitted successfully.
                     </div>

                  }
               </div>
            </div>
         </div>
   )
}
export default AddTransaction
